import axios from 'axios'
import * as API_LINKS from '../../../configurations/links'
import {toast} from 'react-toastify';
import cookie from 'react-cookies'

export const FETCH_MEMBER_LIST = 'FETCH_MEMBER_LIST'
export const RECEIVE_MEMBER_LIST = 'RECEIVE_MEMBER_LIST'
export const FAILED_MEMBER_LIST = 'FAILED_MEMBER_LIST'

export function fetchMemberList(_data){
    if(_data == undefined){
        _data = {
            status: 1
        }
    }
    return (dispatch, getState) => {
        dispatch({type: FETCH_MEMBER_LIST})
        axios({
            method: 'POST',
            url: API_LINKS.MEMBER_LIST_URL,
            headers: {
                Authorization: cookie.load('token')
            },
            data: _data
        })
        .then((response) => {
             if(response.status === 200) {
                if(response.data.status === "success") {
                    dispatch( {
                        type: RECEIVE_MEMBER_LIST,
                        payload: response.data.result
                    })
                   
                } else {
                    dispatch({
                        type: FAILED_MEMBER_LIST
                    })
                    return toast.error(response.data.message);
                }
            } else {
                dispatch({
                    type: FAILED_MEMBER_LIST
                })
                return toast.error(response.data.message);
            }
        })
        .catch(function(error){
            console.log(error)
            if (error.response){
                dispatch({
                    type: FAILED_MEMBER_LIST
                })
                return toast.error(error.response.data.message);;
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/satuan/aSatuan-MemberList.jsx